amzn("trackEvent", "PageVue", {});

window.addEventListener('DOMContentLoaded', () => {
  const allClassicATC = document.querySelectorAll('[js-add-to-cart-btn]');

  allClassicATC.forEach(atc => {
    atc.addEventListener('click', () => {
      amzn("trackEvent", "AjoutAuPanier", {});
    })
  })

  setTimeout(() => {
    const allUpsellATC = document.querySelectorAll('[js-add-to-cart-btn], .rebuy-button');

    allUpsellATC.forEach(atc => {
      atc.addEventListener('click', () => {
        amzn("trackEvent", "AjoutAuPanier", {});
      })
    })
  }, 3000);
})

